import SearchCustom from "../../../components/custom/search-custom";

interface AdminFilterProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
}

export const AdminFilter = ({ searchValue, setSearchValue }: AdminFilterProps) => {
  return (
    <div className="flex flex-col md:flex-row justify-between gap-4 md:gap-8" id="filter-bar">
      <div className="flex flex-col md:flex-row md:flex-wrap gap-4 w-full md:w-auto"></div>

      <div className="w-full md:w-auto md:mt-0">
        <SearchCustom value={searchValue} onChange={(e) => setSearchValue(e)} className="w-full md:w-64" />
      </div>
    </div>
  );
};
